import { createContext, useContext, useEffect } from 'react';
import useState from 'react-usestateref';
import {
    getUserSession,deleteUserSession
  } from '../authorization/FetchToken';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [role, setRole] = useState(null);
  const [userSession, setUserSession,userSessionRef] = useState({
    token: "",
    userId: "",
    orgId: "",
    userName: "",
    orgName: "",
    role: "",
    loginTime: "",
    expiresAt: "",
    paymentStatus: "",
    active: false
  });
  const [loading, setLoading] = useState(true);
  const [expiry, setExpiry] = useState(null);
  
  const initSession = async () => {
    
    const sessionToken = localStorage.getItem('token');
  
    if (!sessionToken) {
      setLoading(false);
      return null;
    }
  
    try {
      const session = await getUserSession(sessionToken);
      const sessionData = session["userSessionData"];
  
      if (sessionData) {
        setUser(sessionData["userName"]);
        setOrg(sessionData["orgName"]);
        setExpiry(sessionData["expiresAt"]);
        setUserSession(sessionData);
        setRole(sessionData["role"]);
      }
  
      return sessionData; //RETURN THIS
    } catch (e) {
      setUser(null);
      setOrg(null);
      return null;
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    initSession();
  }, []);

   const logout = async () => {

    const timestamp = new Date().toISOString();
    const caller = new Error().stack;

    // Save logout information before doing anything else
    const logoutLog = {
        time: timestamp,
        caller: caller
    };

    const existingLogs = JSON.parse(
        localStorage.getItem("logoutLogs") || "[]"
    );

    existingLogs.push(logoutLog);

    localStorage.setItem(
        "logoutLogs",
        JSON.stringify(existingLogs)
    );


    
    setUser(null);
    setOrg(null);
    const sessionToken = localStorage.getItem('token');
    await deleteUserSession(sessionToken,org);
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("jwtExpiry");
    localStorage.removeItem("token");
    localStorage.clear();
  
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });
    window.location.href = "/";
    localStorage.clear();
  };

  
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout" && event.newValue) {
        console.log("Logout detected in another tab");
  
        setUser(null);
        setOrg(null);
        localStorage.clear();
        window.location.href = "/";
      }
    };
  
    window.addEventListener("storage", handleStorageChange);
  
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  
useEffect(() => {
  if (!expiry) return;

  const expiryTime = new Date(expiry).getTime();
  const now = Date.now();
  const timeout = expiryTime - now;

  if (timeout <= 0) { 
    localStorage.clear();
    logout();
    return;
  }

  const timer = setTimeout(() => {
    localStorage.clear();
    logout();
  }, timeout);

  return () => clearTimeout(timer);
}, [expiry]);
  

  return (
    <AuthContext.Provider value={{ user, setUser, org, setOrg, loading, initSession,expiry,setExpiry,userSessionRef,setUserSession,logout,role}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
